import { ReservationsTable } from './components/reservations-table/ReservationsTable';

const Reservations = () => {
  return (
    <div className="w-full">
      <ReservationsTable />
    </div>
  );
};

export default Reservations;
